/**
 * Custom [EventTarget](https://developer.mozilla.org/en-US/docs/Web/API/EventTarget)
 * where only the latest listener for any given event type is called.
 * This supports having multiple dialogs open at once.
 */
export var DialogEventTarget = /*#__PURE__*/function () {
  function DialogEventTarget() {
    // Keep track of the listeners for each event type, e.g.
    // 'click': [ listener, listener ]
    this.listeners = {};
    // Keep track of the handlers for each event type, e.g.
    // 'click': handler
    this.handlers = {};
  }
  var _proto = DialogEventTarget.prototype;
  _proto.addEventListener = function addEventListener(type, listener) {
    var _this = this;
    if (!type || !listener || typeof document === 'undefined') {
      return;
    }
    if (!this.listeners[type]) {
      // First listener for this event type, start a new list of listeners and initalize the
      // document listener
      this.listeners[type] = [listener];
      this.handlers[type] = function () {
        var listeners = _this.listeners[type];
        if (listeners) {
          listeners[listeners.length - 1].apply(listeners, arguments);
        }
      };
      document.addEventListener(type, this.handlers[type]);
    } else if (!this.listeners[type].includes(listener)) {
      // New listeners always go to the top of the stack
      // Prevents adding the same listener multiple times, for React.StrictMode
      // @see CDS-3212
      this.listeners[type].push(listener);
    }
  };
  _proto.removeEventListener = function removeEventListener(type, listener) {
    if (!type || !listener || typeof document === 'undefined' || !this.listeners[type]) {
      return;
    }
    var index = this.listeners[type].indexOf(listener);
    if (index >= 0) {
      this.listeners[type].splice(index, 1);
    }

    // If this was the last listener for the event, remove the document listener
    if (!this.listeners[type].length) {
      document.removeEventListener(type, this.handlers[type]);
      delete this.handlers[type];
      delete this.listeners[type];
    }
  };
  return DialogEventTarget;
}();